(function () {

    "use strict";

    angular
        .module('harriApp')
        .component('searchPagesNavigatorComponent', {
            controller: SearchPagesNavigatorComponent,
            bindings: {
                brandId: "<?"
            },
            templateUrl: '../hmodules/talent-pool/components/search-pages-navigator/search-pages-navigator.component.html'
        });

    SearchPagesNavigatorComponent.$inject = ['$q', '$state', 'hUser', 'brandServices', 'talentPoolDataService', 'ShortListData', '$scope', '$filter', 'hmapService'];

    function SearchPagesNavigatorComponent($q, $state, hUser, brandServices, talentPoolDataService, ShortListData, $scope, $filter, hmapService) {
        var self = this;

        var isGPLevel = false;
        var isGlobalTalentPoolServiceEnabled = false;
        var showExtraLinks = false;
        var isFromUK = false;
        var isEmployer = false;
        var isLoggedIn = false;
        var tabTitlesMap = {
            'appLayout.harriSH.search.apprentice-jobs': $filter('translate')('Jobs'),
            'appLayout.harriSH.search.pride-apprentice-jobs': $filter('translate')('Jobs'),
            'appLayout.harriSH.search.jobs': $filter('translate')('Jobs'),
            'appLayout.harriSH.search.all': $filter('translate')('All'),
            'appLayout.harriSH.search.companies': $filter('translate')('Companies'),
            'appLayout.harriSH.search.people': $filter('translate')('People'),
            'appLayout.harriSH.search.shortlist': $filter('translate')('Shortlist'),
            'appLayout.harriSH.talent-pool': $filter('translate')('Talent pool'),
        };

        self.ShortListData = ShortListData;

        self.isActiveTab = function (tab) {
            return $state.current.name === tab.url;
        };

        self.getActiveTab = function () {
            return tabTitlesMap[$state.current.name];
        };

        self.goToPage = function (tab) {
            $state.go(tab.url, tab.params);
        };

        self.getActiveBrand = function () {
            /* ---- ---- ---- ----- ---- ---- ---- */
            /* ---- WARNING: duplicated logic ---- */
            /* ---- ---- ---- ----- ---- ---- ---- */

            if (!isEmployer) {
                return;
            }
            var brandId;
            if (self.brandId) {
                brandId = self.brandId;
            } else if (hUser.isTopLevelContext()) {
                brandId = hmapService.getActiveBrand();
            } else {
                var brandList = hUser.getUser().brands_list;
                var found = _.find(brandList, {"id": hUser.getUserContext().brand_id});
                if (found) {
                    brandId = hUser.getUserContext().brand_id;
                } else {
                    brandId = brandList && brandList.length && brandList[0] && brandList[0].id;
                }
            }

            return brandId;
        };

        var initTabs = function () {
            if ($state.current.name === 'appLayout.harriSH.search.apprentice-jobs') {
                self.tabs = [
                    {
                        displayName: $filter("translate")("Jobs"),
                        code: 'jobs',
                        url: 'appLayout.harriSH.search.apprentice-jobs',
                    }
                ];
            } else if ($state.current.name === 'appLayout.harriSH.search.pride-apprentice-jobs') {
                self.tabs = [
                    {
                        displayName: $filter("translate")("Jobs"),
                        code: 'jobs',
                        url: 'appLayout.harriSH.search.pride-apprentice-jobs',
                    }
                ];
            } else {
                self.tabs = [
                    {
                        displayName: $filter("translate")("All"),
                        code: 'all',
                        url: 'appLayout.harriSH.search.all',
                        hidden: isLoggedIn && isEmployer || (isFromUK && $state.current.name === 'appLayout.harriSH.search.jobs')
                    }, {
                        displayName: $filter("translate")("Jobs"),
                        code: 'jobs',
                        url: 'appLayout.harriSH.search.jobs',
                        hidden: isLoggedIn && isEmployer  || (isFromUK && $state.current.name === 'appLayout.harriSH.search.jobs')
                    }, {
                        displayName: $filter("translate")("Companies"),
                        code: 'companies',
                        url: 'appLayout.harriSH.search.companies',
                        hidden: isLoggedIn && isEmployer || (isFromUK && $state.current.name === 'appLayout.harriSH.search.jobs')
                    }, {
                        displayName: $filter("translate")("People"),
                        code: 'people',
                        url: 'appLayout.harriSH.search.people',
                        hidden: !isLoggedIn || ((isEmployer && (isGPLevel && (!isGlobalTalentPoolServiceEnabled || !showExtraLinks))) || (isFromUK && $state.current.name === 'appLayout.harriSH.search.jobs'))
                    }, {
                        displayName: $filter("translate")("Shortlist"),
                        code: 'shortlist',
                        url: 'appLayout.harriSH.search.shortlist',
                        hidden: !isEmployer || (isGPLevel && (!isGlobalTalentPoolServiceEnabled || !showExtraLinks))
                    }, {
                        displayName: $filter("translate")("Talent pool"),
                        code: 'talent-pool',
                        url: 'appLayout.harriSH.talent-pool',
                        params: {
                            brandId: isLoggedIn && self.getActiveBrand()
                        },
                        hidden: !isEmployer || (isGPLevel && !isGlobalTalentPoolServiceEnabled)
                    }
                ];
            }
        };

        var isNavigatorMultiSelect = function (tabs) {
            if (tabs && tabs.length && tabs.length > 1) {
                var visibleOptions = tabs.filter(function (tab) {
                    return !tab.hidden;
                });
                
                return visibleOptions.length > 1;
            }
        };

        var init = function () {
            isEmployer = hUser.isEmployer();
            isLoggedIn = hUser.isLoggedIn();
            var promises = {};
            promises['fromUK'] = hUser.isFromUK();
            if (isEmployer) {
                isGPLevel = hUser.isTopLevelContext();
                promises['GlobalTalentPoolService'] = brandServices.check(brandServices.SERVICES.GLOBAL_TALENT_POOL, self.getActiveBrand());
                promises['GlobalTalentPoolSettings'] = talentPoolDataService.getBrandTalentPoolSettings(self.getActiveBrand());
            }

            $q.all(promises)
                .then(function (res) {
                    isFromUK = res['fromUK'];
                    if (isEmployer) {
                        isGlobalTalentPoolServiceEnabled = res['GlobalTalentPoolService'];
                        showExtraLinks = res['GlobalTalentPoolSettings'].display_extra_links;
                    }
                }, function (err) {
                    console.error(err);
                })
                .finally(function () {
                    initTabs();
                    self.multiSelect = isNavigatorMultiSelect(self.tabs);
                });


            if (isLoggedIn && !ShortListData.initialized) {
                ShortListData.init();
            }

        };

        self.$onInit = function () {
            init();
        };
    }

})();
